import { connectClearRefinements } from "instantsearch.js/es/connectors/index.js";
import { clearRefinements } from "instantsearch.js/es/widgets/index.js";

export const chamfrClearAllFilters = (params) => {
  return clearRefinements({
    ...params,
    cssClasses: {
      button: ["clear-filters"],
      disabledButton: "disabled",
    },
    templates: {
      resetLabel({ hasRefinements }, { html }) {
        return html`<span
          >${hasRefinements ? "Clear All Filters" : "Clear All Filters"}</span
        >`;
      },
    },
  });
};
